// extracted by mini-css-extract-plugin
module.exports = {"overlayWrapper":"Overlay_overlayWrapper__2IjyR","overlay":"Overlay_overlay__32LUA","visible":"Overlay_visible__pd-2q"};